/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Button, INodeProps, Modal, ModalBody, ModalFooter, ModalHeader, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IOrderTemplateLineViewProps } from './components';
import { IOrderTemplateViewProps } from './krannich-c-order-template';
import { incExcPriceFormat } from '../../utils/helper';

const OrderTemplateLinesView: React.FC<IOrderTemplateViewProps> = (props: IOrderTemplateViewProps) => {
    const {
        OrderTemplateLines,
        status,
        statusMessage,
        heading,
        ProductsTable,
        ProductsTableHeading,
        orderLines,
        ProductsTableRow,
        productsStatusMessage,
        OrderTemplateActions,
        orderActions,
        pagination,
        // itemAddedToCartDialog,
        bulkOrderLineActions,
        isDetailsDisplayed,
        detailedProductView,
        toggleDetailsDisplayed,
        isSelectedProdPopUpShow,
        addedLinesToPassArr,
        addedLinesToPassArrSuccessfull,
        isAllselectedItemsAddedSuccessfully,
        _handlerToClearSelectedPopUp,
        resources: {
            cancelBtnLabel,
            productNumberText,
            productText,
            productUnitPriceText,
            productUOMText,
            productQuantityText,
            renameOrderTemplateButtonText
        },
        context
    } = props;

    const { enabledIncExPrices, incExPricePercentage } = props.context.app.config;
    const { addedToCartFailureCustomMessage, zeroPriceProductText } = props.resources;
    const toggleDetails = React.useCallback(() => {
        toggleDetailsDisplayed && toggleDetailsDisplayed(undefined);
    }, [toggleDetailsDisplayed]);
    //VSI Customization to set toogle Values
    const [toogleShow, setToogleShow] = React.useState<boolean>(false);
    const [deletedToogleShow, setDeletedToogleShow] = React.useState<boolean>(false);
    const [indexValue, setIndexValue] = React.useState<number>();
    //VSI CUSTOMIZATION TO CREATE OUR OWN CUSTOMN ADD TO CART BUTTON
    const addToBagButton = (index: number) => {
        const clickValue = () => {
            setToogleShow(!toogleShow);
            setIndexValue(index);
        };
        return (
            <div className='add-bag-template' onClick={clickValue}>
                ADD TO CART
            </div>
        );
    };
    const addToBagButtonDisabled = () => {
        return <div className='add-bag-template-disabled'>ADD TO CART</div>;
    };
    //VSI CUSTOMIZATION TO CREATE OUR OWN CUSTOMN REMOVE BUTTON
    const removeButtonCustom = (index: number) => {
        const clickValue = () => {
            setDeletedToogleShow(!deletedToogleShow);
            setIndexValue(index);
        };
        return (
            <div className='delete-template-product' onClick={clickValue}>
                Delete
            </div>
        );
    };

    const _renderItem = (
        product: IOrderTemplateLineViewProps,
        quantityLabel: string,
        ProductsTableRow?: INodeProps,
        toogleShow?: boolean,
        setToogleShow?: React.Dispatch<React.SetStateAction<boolean>>,
        deletedToogleShow?: boolean,
        setDeletedToogleShow?: React.Dispatch<React.SetStateAction<boolean>>,
        productsStatusMessage?: React.ReactNode,
        index?: number
    ): JSX.Element | null => {
        //VSI CUSTOMIZATION FOR PRODUCT MODAL AND DELETE MODAL
        const ShowModal = () => {
            return (
                <Modal
                    wrapClassName='ms-order-template-add-to-cart-custom'
                    autoFocus
                    fade={false}
                    applicationNode='renderPage'
                    isOpen={true}
                    toggle={() => {
                        setToogleShow && setToogleShow(false);
                    }}
                >
                    <div className='alert-modal-body-container'>
                        <ModalHeader
                            toggle={() => {
                                setToogleShow && setToogleShow(false);
                            }}
                        >
                            Add 1 Item to Cart
                        </ModalHeader>
                        <ModalBody>
                            <div className='order-template-modal-contianer'>
                                <div className='image-contianer'>{productImage}</div>
                                <div className='information-container'>
                                    <div className='detail-contianer'>
                                        <div className='_info'>{productInfo}</div>
                                        <div className='_number'>
                                            <span>Item Number:&nbsp;</span>
                                            {productNumber}
                                        </div>
                                        <div className='_price'>
                                            <span>Unit Price:</span>
                                            {productPrice}
                                        </div>
                                        <div className='_uom'>
                                            <span>UOM: </span> {productUnitOfMeasure}
                                        </div>
                                    </div>
                                    <div className='quantity-container'>
                                        <div className='_quantity'>
                                            <span>Quantity </span>
                                            {productQuantityView}
                                        </div>
                                    </div>
                                </div>
                                {productsStatusMessage ? <span className='status-message'>{productsStatusMessage}</span> : null}
                            </div>
                            <div className='footer-container'>
                                {product.totalPrice === 0 ? (
                                    <></>
                                ) : (
                                    // <div className='total-price-container'>
                                    //     <span>Total A$ {totalBeforeTax}</span>
                                    // </div>
                                    <div className='total-price-container'>
                                        <span>
                                            Total{' '}
                                            {incExcPriceFormat(product.totalPrice!, context, enabledIncExPrices, incExPricePercentage)}
                                        </span>
                                    </div>
                                )}
                                <div className='actions-container'>
                                    {product.isRequestPrice || product.isDiscontinued ? (
                                        <button className='_action-btn' disabled={true}>
                                            Add to cart
                                        </button>
                                    ) : (
                                        <span
                                            className='_action-btn'
                                            onClick={() => {
                                                setTimeout(() => {
                                                    setToogleShow && setToogleShow(false);
                                                }, 5000);
                                            }}
                                        >
                                            Add to cart {product.addToBagButton}
                                        </span>
                                    )}

                                    <button
                                        className='msc-delete-orderTemplateList-btn btn  cancel-btn '
                                        onClick={() => {
                                            setToogleShow && setToogleShow(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </ModalBody>
                    </div>
                </Modal>
            );
        };
        const DeleteModal = () => {
            return (
                <Modal
                    wrapClassName='ms-order-template-add-to-cart-custom modal-width-parent'
                    autoFocus
                    fade={false}
                    applicationNode='renderPage'
                    isOpen={true}
                    toggle={() => {
                        setDeletedToogleShow && setDeletedToogleShow(false);
                    }}
                >
                    <div className='alert-modal-body-container'>
                        <ModalHeader
                            toggle={() => {
                                setDeletedToogleShow && setDeletedToogleShow(false);
                            }}
                        >
                            Delete Product
                        </ModalHeader>
                        <ModalBody>
                            <div>
                                <span>Do you want to delete the product from order template?</span>
                            </div>
                            <div className='actions-container'>
                                <span className='_action-btn'>Delete {removeButton}</span>

                                <button
                                    className='msc-delete-orderTemplateList-btn btn  cancel-btn '
                                    onClick={() => {
                                        setDeletedToogleShow && setDeletedToogleShow(false);
                                    }}
                                >
                                    Back
                                </button>
                            </div>
                        </ModalBody>
                    </div>
                </Modal>
            );
        };

        if (!product) {
            return null;
        }

        const {
            key,
            selectLine,
            productImage,
            productPrice,
            productNumber,
            removeButton,
            productInfo,
            productUnitOfMeasure,
            productQuantityView,
            productQuantity,
            popUp,
            isMobile,
            isDiscontinued,
            isRequestPrice
        } = product;

        return (
            <>
                {toogleShow && index === indexValue && <ShowModal />}
                {deletedToogleShow && index === indexValue && <DeleteModal />}
                <Node key={key} className={ProductsTableRow!.className} {...ProductsTableRow}>
                    <td>{selectLine}</td>
                    {/* <td>{productImage}</td> */}
                    {isMobile ? (
                        <td>
                            <div className='product-name'>{productInfo}</div>
                            <div>
                                {quantityLabel}: {productQuantity}
                            </div>
                        </td>
                    ) : (
                        <td>{productNumber}</td>
                    )}
                    {!isMobile && <td>{productInfo}</td>}
                    {!isMobile && <td>{productPrice}</td>}
                    {!isMobile && <td>{productUnitOfMeasure}</td>}
                    {!isMobile && <td>{productQuantityView}</td>}
                    {isMobile && <td>{popUp}</td>}
                    {!isMobile && (
                        <td>
                            {isDiscontinued || isRequestPrice ? addToBagButtonDisabled() : addToBagButton(index!)}
                            {removeButtonCustom(index!)}
                        </td>
                    )}
                </Node>
            </>
        );
    };

    //VSI CUSTOMIZATION END
    return (
        <>
            {isSelectedProdPopUpShow && (
                <Modal
                    wrapClassName='ms-order-template-mobile-view-modal'
                    autoFocus
                    fade={false}
                    applicationNode='renderPage'
                    isOpen={isSelectedProdPopUpShow}
                    toggle={() => _handlerToClearSelectedPopUp()}
                >
                    <ModalHeader
                        className='msc-lines-added-to-cart-dialog__dialog__header msc-modal__header'
                        toggle={() => _handlerToClearSelectedPopUp()}
                    >
                        {status === 'FAILEDBYZEROPRICE' ? (
                            <h5 className='msc-modal__title error'>
                                <b>{zeroPriceProductText}</b>
                            </h5>
                        ) : (
                            <>
                                {status === 'SUCCESS' ? (
                                    addedLinesToPassArr.length > 1 ? (
                                        <h5 className='msc-modal__title'>
                                            <b>{addedLinesToPassArrSuccessfull?.length} Products</b>
                                            <span> added to Cart</span>
                                        </h5>
                                    ) : (
                                        <h5 className='msc-modal__title'>
                                            <b>{addedLinesToPassArr.length} Product</b>
                                            <span> added to Cart</span>
                                        </h5>
                                    )
                                ) : (
                                    <h5 className='msc-modal__title error'>
                                        <b>{addedToCartFailureCustomMessage}</b>
                                    </h5>
                                )}
                            </>
                        )}
                    </ModalHeader>
                    <ModalBody className='msc-lines-added-to-cart-dialog__dialog__body msc-modal__body'>
                        {/* <div className='_header-details'>
                            <span className='_name'>Name</span>
                            <span className='_quantity'>Quantity</span>
                        </div> */}
                        {addedLinesToPassArrSuccessfull &&
                            addedLinesToPassArrSuccessfull?.map(e => {
                                return (
                                    e &&
                                    e.product && (
                                        <div className='_details'>
                                            <span className='_prod-name'>{e?.product?.Name!}</span>
                                            {/* <span className='_prod-quantity'>{e?.productListLine?.Quantity!}</span> */}
                                        </div>
                                    )
                                );
                            })}
                        {isAllselectedItemsAddedSuccessfully ? (
                            <span className='all-products-not-added'>
                                {'Only those items that do not exceed the quantity limits and have a price are added to cart.'}
                            </span>
                        ) : null}
                    </ModalBody>
                    <ModalFooter className='msc-lines-added-to-cart-dialog__dialog__footer msc-modal__footer'>
                        <a
                            href={
                                props.config.viewCartAndCheckoutLinkForSelectedItemPopup &&
                                props.config.viewCartAndCheckoutLinkForSelectedItemPopup.linkUrl &&
                                props.config.viewCartAndCheckoutLinkForSelectedItemPopup.linkUrl.destinationUrl
                            }
                            className='msc-lines-added-to-cart-dialog__dialog__view-cart-button msc-btn'
                        >
                            View Cart And Checkout
                        </a>
                        <Button
                            onClick={() => _handlerToClearSelectedPopUp()}
                            className='msc-lines-added-to-cart-dialog__dialog__continue-shopping msc-btn'
                        >
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
            )}
            <Module {...OrderTemplateLines}>
                {heading}
                <div className='order-template-heading-custom-div'>
                    {OrderTemplateActions && (
                        <Node {...OrderTemplateActions}>
                            <div className='order-template-buttons-custom-div'>
                                {orderActions?.addTemplateToBag}
                                {orderActions?.renameTemplate}
                                {orderActions?.removeTemplate}
                                {!isDetailsDisplayed && productsStatusMessage}
                            </div>
                        </Node>
                    )}
                </div>
                {bulkOrderLineActions}
                {status !== 'SUCCESS' && statusMessage}
                {ProductsTable && orderLines && orderLines.length > 0 && (
                    <Node className='ms-order-template__content'>
                        <Node {...ProductsTable}>
                            {ProductsTableHeading}
                            <tbody>
                                {orderLines &&
                                    orderLines.map((product, index) => {
                                        return _renderItem(
                                            product,
                                            productQuantityText,
                                            ProductsTableRow,
                                            toogleShow,
                                            setToogleShow,
                                            deletedToogleShow,
                                            setDeletedToogleShow,
                                            productsStatusMessage,
                                            index
                                        );
                                    })}
                            </tbody>
                        </Node>
                        {pagination}
                    </Node>
                )}
                {/* {itemAddedToCartDialog} */}
                <Modal
                    wrapClassName='ms-order-template-mobile-view-modal'
                    autoFocus
                    fade={false}
                    applicationNode='renderPage'
                    isOpen={isDetailsDisplayed}
                    toggle={toggleDetails}
                >
                    <ModalHeader toggle={toggleDetails}>Product Details</ModalHeader>
                    <ModalBody>
                        <ul>
                            {/* <li>{detailedProductView?.productImage}</li> */}
                            <li className='product-info'>
                                <span>{productText}:</span>
                                {detailedProductView?.productInfo}
                            </li>
                            <li>
                                <span>{productNumberText}:</span>
                                {detailedProductView?.productNumber}
                            </li>
                            <li>
                                <span>{productUnitPriceText}:</span> {detailedProductView?.productPrice}
                            </li>
                            <li>
                                <span>{productUOMText}:</span> {detailedProductView?.productUnitOfMeasure}
                            </li>
                            <li>
                                <span>{productQuantityText}:</span>
                                {detailedProductView?.productQuantityView}
                            </li>
                            {productsStatusMessage && <li>{productsStatusMessage}</li>}
                        </ul>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={toggleDetails} className='msc-add-order-template-to-cart btn-update-template msc-btn'>
                            {renameOrderTemplateButtonText}
                        </Button>
                        <Button onClick={toggleDetails}>{cancelBtnLabel}</Button>
                    </ModalFooter>
                </Modal>
            </Module>
        </>
    );
};

export default OrderTemplateLinesView;
